import { TTupleOfTwoNumbers } from '../types';

export const getRadiusInPx = (diameter: number, graphWidth: number, domains: TTupleOfTwoNumbers): number => (diameter * graphWidth) / domains[0] / 2;
